<template>
  <div>
    <!-- <my-header ></my-header> -->
    <div class="bannerWrap">
      <my-header></my-header>
    </div>
    <div class="webbg">
      <div class="web">
        <div class="producttitle">
          选择型号<span>首页 > 产品定制</span>
        </div>
        <div class="productschedule">
          <a href="javascript:;"
             class="cur">型号选择</a>
          <a href="javascript:;">选择颜色</a>
          <a href="javascript:;">个性设计定制</a>
          <a href="#">个人资料</a>
          <a href="javascript:;">确认购买</a>
        </div>

        <div class="productsbox clearfl">
            
          <div class="productright">

            <!--为了适应响应式 所以复制结构-->
            <div class="m-productmodel-container">

              <div class="m-productmodel-scroll">
                <div class="productmodel clearfl">
                  <!--左边耳机-->
                  <div class="productmodelleft"
                       @click='changeselectleft()'>
                    <!--自定义上传-->
                    <div class="headsetcustommade">
                    <div class="custommade leftcustomize"
                             v-bind:style="{backgroundImage:'url('+CustomUplod.leftimg+')',      
                            width:CustomUplod.Lwidth + '%',
                            height:CustomUplod.Lheight + '%',
                            left:CustomUplod.Lleft + '%',
                            top:CustomUplod.Ltop + '%',
                            transform:'rotate('+CustomUplod.Lrotate+'deg) scale('+CustomUplod.Lscale+')'
                      }">

                        </div>
                      <div class="headsetsmalllogo"></div>
                    </div>
                    <!--耳机线-->
                    <div class="headsetline" v-bind:style="{backgroundImage:'url(' + SelectDesign.Wleftimg + ')'}"></div>
                    <!--耳机壳-->
                    <div class="headsetmold"
                         v-bind:style="{backgroundImage:'url(' + SelectDesign.Krightimg + ')'}"></div>
                    <!--耳机壳加金箔粉-->
                    <div class="headsetgold"
                         v-bind:style="{backgroundImage:'url(' + SelectDesign.KADDleftimg + ')'}"></div>
                    <!--耳机模-->
                    <div class="headsetcover"
                         v-bind:style="{backgroundImage:'url(' + SelectDesign.rightimg + ')'}"></div>
                    <!--耳机模加金箔粉-->
                    <div class="headsetother"
                         v-bind:style="{backgroundImage:'url(' + SelectDesign.addleftimg + ')'}"></div>
                    <!--耳机logo-->
                    <div class="headsetBiglogo" 
                    v-bind:style="{backgroundImage:'url('+ httpurl + DesignMake.leftlogoimg +  ')'}">
                    </div>
 <!-- <div class="headsetBiglogo"
                           v-bind:style="{backgroundImage:'url(' + httpurl + DesignMake.leftlogoimg + ')'}"></div> -->
                  </div>
                  <!--左边耳机-->

                  <!--右边耳机-->
                  <div class="productmodelright"
                       @click='changeselectright()'>
                    <!--自定义上传-->
                    <div class="headsetcustommade">
                      <div class="custommade rightcustomize"
                             v-bind:style="{backgroundImage:'url('+CustomUplod.rightimg+')',      
                            width:CustomUplod.Rwidth + '%',
                            height:CustomUplod.Rheight + '%',
                            left:CustomUplod.Rleft + '%',
                            top:CustomUplod.Rtop + '%',
                            transform:'rotate('+CustomUplod.Rrotate+'deg) scale('+CustomUplod.Rscale+')'
                      }"></div>
                      <div class="headsetsmalllogo"></div>
                    </div>
                    <!--耳机线-->
                    <div class="headsetline" v-bind:style="{backgroundImage:'url(' + SelectDesign. Wrightimg+ ')'}"> </div>
                    <!--耳机壳-->
                    <div class="headsetmold"
                         v-bind:style="{backgroundImage:'url(' + SelectDesign. Kleftimg+ ')'}"> </div>
                    <!--耳机壳加金箔粉-->
                    <div class="headsetgold"
                         v-bind:style="{backgroundImage:'url(' + SelectDesign.KADDrightimg + ')'}"></div>
                    <!--耳机模-->
                    <div class="headsetcover"
                         v-bind:style="{backgroundImage:'url(' + SelectDesign.leftimg+ ')'}"></div>
                    <!--耳机模加金箔粉-->
                    <div class="headsetother"
                         v-bind:style="{backgroundImage:'url(' + SelectDesign.addrightimg + ')'}">></div>
                    <!--耳机logo-->
                    <div class="headsetBiglogo"
                   v-bind:style="{backgroundImage:'url(' + httpurl + DesignMake.rightlogoimg + ')'}">
                   
                    </div>
                  </div>
                  <!--右边耳机-->
                </div>
              </div>

            </div>
          </div>
          <div class="productleft">

            <div class="productmodel-container">

              <div class="productmodel clearfl">
                <!--左边耳机-->
                <div class="productmodelleft">
                  <!--自定义上传-->
                  <div class="headsetcustommade">
                    <div class="custommade leftcustomize"
                           v-bind:style="{backgroundImage:'url('+CustomUplod.leftimg+')',      
                            width:CustomUplod.Lwidth + '%',
                            height:CustomUplod.Lheight + '%',
                            left:CustomUplod.Lleft + '%',
                            top:CustomUplod.Ltop + '%',
                            transform:'rotate('+CustomUplod.Lrotate+'deg) scale('+CustomUplod.Lscale+')'
                      }">

                      </div>
                    <div class="headsetsmalllogo"></div>
                  </div>
                  <!--耳机线-->
                  <div class="headsetline" v-bind:style="{backgroundImage:'url(' + SelectDesign.Wleftimg + ')'}"></div>
                  <!--耳机壳-->
                  <div class="headsetmold"
                       v-bind:style="{backgroundImage:'url(' + SelectDesign.Krightimg + ')'}"></div>
                  <!--耳机壳加金箔粉-->
                  <div class="headsetgold"
                       v-bind:style="{backgroundImage:'url(' + SelectDesign.KADDleftimg + ')'}"></div>
                  <!--耳机模-->
                  <div class="headsetcover"
                       v-bind:style="{backgroundImage:'url(' + SelectDesign.rightimg + ')'}"></div>
                  <!--耳机模加金箔粉-->
                  <div class="headsetother"
                       v-bind:style="{backgroundImage:'url(' + SelectDesign.addleftimg + ')'}"></div>
                  <!--耳机logo-->
                  <div class="headsetBiglogo" 
                    v-bind:style="{backgroundImage:'url('+ httpurl + DesignMake.leftlogoimg +  ')'}">
                    </div>

                </div>
                <!--左边耳机-->

                <!--右边耳机-->
                <div class="productmodelright">
                  <!--自定义上传-->
                  <div class="headsetcustommade">
                  <div class="custommade rightcustomize"
                           v-bind:style="{backgroundImage:'url('+CustomUplod.rightimg+')',      
                            width:CustomUplod.Rwidth + '%',
                            height:CustomUplod.Rheight + '%',
                            left:CustomUplod.Rleft + '%',
                            top:CustomUplod.Rtop + '%',
                            transform:'rotate('+CustomUplod.Rrotate+'deg) scale('+CustomUplod.Rscale+')'
                      }"></div>
                    <div class="headsetsmalllogo"></div>
                  </div>
                  <!--耳机线-->
                  <div class="headsetline" v-bind:style="{backgroundImage:'url(' + SelectDesign.Wrightimg + ')'}"> </div>
                  <!--耳机壳-->
                  <div class="headsetmold"
                       v-bind:style="{backgroundImage:'url(' + SelectDesign.Kleftimg + ')'}"> </div>
                  <!--耳机壳加金箔粉-->
                  <div class="headsetgold"
                       v-bind:style="{backgroundImage:'url(' + SelectDesign.KADDrightimg + ')'}"></div>
                  <!--耳机模-->
                  <div class="headsetcover"
                       v-bind:style="{backgroundImage:'url(' + SelectDesign.leftimg + ')'}"></div>
                  <!--耳机模加金箔粉-->
                  <div class="headsetother"
                       v-bind:style="{backgroundImage:'url(' + SelectDesign.addrightimg + ')'}"></div>
                  <!--耳机logo-->
                  <div class="headsetBiglogo"
                   v-bind:style="{backgroundImage:'url(' + httpurl + DesignMake.rightlogoimg + ')'}">
                   
                    </div>
                </div>
                <!--右边耳机-->
              </div>

            </div>

          </div>

          <div class="LL-productright">
            <div class="productclass">
              <a v-for="(item,index) in Model"
                 :key="index"
                 @click="Update(item)"
                 :class="{'cur':item.id==designid}">{{item.Name}}</a>
            </div>
          </div>

        </div>

        <div class="ll-productcontent clearfl">

          <div class="productdescription">
            <h3>产品描述</h3>
            <div class="productcontent">
              {{ Description}}
            </div>
          </div>

          <div class="productcontenttitle">
            <dl>
              <dt>
                <h3>你的<span class="Pmodel">{{Name}}</span></h3>
                <p>型号：<span class="Pmodel">{{Name}}</span><span>￥<i class="modelprice">{{Price}}</i></span></p>
                <p>&nbsp;</p>
                <p>&nbsp;</p>
                <h4>耳机定制完成时间：<span>2-4周</span></h4>
                <h5>总价格<span>￥<i class="modelprice">{{Price}}</i></span></h5>
              </dt>
              <dd>
                <a>上一步</a>
                <a class="cur"
                   @click='next(Description,Name,Price,designid)'>下一步</a>
              </dd>
            </dl>
          </div>

        </div>

      </div>
    </div>

  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import myHeader from "@/views/designimg";
import { getdexh } from "@/api/api";

export default {
  components: { myHeader },
  data () {
    return {
          CustomUplod: {
        leftimg: '',
        rightimg: '',
        Lwidth: 20.5,
        Lheight: 19.7321,
        Lleft: 44.4167,
        Ltop: 50.134,
        Lrotate: 0,
        Lscale: 1,
        Rwidth: 20.5,
        Rheight: 19.7321,
        Rleft: 44.4167,
        Rtop: 50.134,
        Rrotate: 0,
        Rscale: 1
      },
         DesignMake: {
           LLogoColorNameid: '',
        RLogoColorNameid: '',
        LLogoColorName: '',
        RLogoColorName: '',
        LLogoStyleName: '',
        RLogoStyleName: '',
        LLogoStyleNameid: '',
        RLogoStyleNameid: '',
        SumPrice: 0,
        leftlogoimg: '',
        rightlogoimg: '',
         
        },
      designid: '',
      SelectDesign: {
           Wrightimg: require("../assets/right.png"),
            Wleftimg: require("../assets/left.png"),
        PanelOtherid: 4,
       rightimg: require("../assets/left02.png"),
        leftimg : require("../assets/right02.png"),
        addleftimg: "",
        addrightimg: "",
        //						addleftimg: require("../assets/leftjfkt.png"),
        //						addrightimg: require("../assets/rightjfkt.png"),
         Krightimg: require("../assets/left01.png"),
       Kleftimg: require("../assets/right01.png"),
        KADDleftimg: "",
        KADDrightimg: "",
        Mleftname: "",
        Mrightname: "",
        Mprice: 0,
        Kaddleftname: "",
        Kaddrightname: "",
        Kaddprice: 0,
        Maddleftname: "",
        Maddrightname: "",
        Maddprice: 0,
        Kleftname: "",
        Krightname: "",
        Kprice: 0,
        Wname: "",
        ukey:0,
        Wprice: ""
      },
      Description: " ",
      Name: "",
      Price: 0,
      httpurl: "http://shop.qdc.com/",
      Model: ''
    };
  },
  created () {   
      if (localStorage.getItem('newukey') == '' || localStorage.getItem('newukey') == null) {
        this.ukey = 0
      }else{
          this.ukey=localStorage.getItem('newukey')
          
      }
       this.getdexhList()
    

    if (localStorage.getItem("newSelectDesign") != null||localStorage.getItem("newSelectDesign") != undefined) {
      var SelectDesign = JSON.parse(localStorage.getItem('newSelectDesign'));
      this.SelectDesign.KADDleftimg = this.httpurl + SelectDesign.KADDleftimg

      this.SelectDesign.KADDrightimg = this.httpurl + SelectDesign.KADDrightimg

      this.SelectDesign.Kaddleftname = this.httpurl + SelectDesign.Kaddleftname

      this.SelectDesign.Kleftimg = this.httpurl + SelectDesign.Kleftimg

      this.SelectDesign.Krightimg = this.httpurl + SelectDesign.Krightimg
      this.SelectDesign.addleftimg = this.httpurl + SelectDesign.addleftimg

      this.SelectDesign.addrightimg = this.httpurl + SelectDesign.addrightimg
      this.SelectDesign.leftimg = this.httpurl + SelectDesign.leftimg

      this.SelectDesign.leftlogoimg = this.httpurl + SelectDesign.leftlogoimg
      this.SelectDesign.rightimg = this.httpurl + SelectDesign.rightimg

      this.SelectDesign.rightlogoimg = this.httpurl + SelectDesign.rightlogoimg
      this.SelectDesign.Wleftimg  = this.httpurl + SelectDesign.Wleftimg 
      this.SelectDesign.Wrightimg  = this.httpurl + SelectDesign.Wrightimg 

    }
     if (localStorage.getItem("newDesignMake") != null||localStorage.getItem("newDesignMake") != undefined) {
      var DesignMake = JSON.parse(localStorage.getItem('newDesignMake'));
      this.DesignMake = DesignMake
    }
    if (localStorage.getItem("newCustomUplod") != null||localStorage.getItem("newCustomUplod") != undefined) {
      var CustomUplod = JSON.parse(localStorage.getItem('newCustomUplod'));
      this.CustomUplod = CustomUplod   
    }

   

  },


  methods: {
    getdexhList () {

      var para = {
        // name:this.name,
        // style:this.style,
        // quality:this.quality,
        // else:this.elseask
      };

      getdexh(para).then(res => {
        // console.log("DesginList请求成功", res.data.DesginList);
        this.Model = res.data.DesginList
        if (localStorage.getItem("newDesginList") != null||localStorage.getItem("newDesginList") != undefined) {
      var list = JSON.parse(localStorage.getItem('newDesginList'));
      this.Description = list.Description
      this.Name = list.Name;
      this.Price = list.Price;
      this.designid = list.designid
    }else{
this.Description = res.data.DesginList[0].Description
        this.Name = res.data.DesginList[0].Name
        this.Price = res.data.DesginList[0].Price
        this.designid= res.data.DesginList[0].id
    }
         
        //  this.$store.dispatch("ChangeDesginList", res.data.DesginList[0]);
        //  this.Boxs= res.data. Boxs
        //   this.Xiancai= res.data.Wires['0']
        //    this.Baozhuang= res.data.Boxs['0']

        res => {
          console.info("调用失败", res);
        };
      });
    },
    purchase () {
      this.$router.push("/WirelessHeadset");
    },
    Update (item) {
      this.designid = item.id;
    
        this.Description = item.Description;
        this.Name = item.Name;
        this.Price = item.Price;
        					// console.log(  this.Description )
      
    },
    next (Description, Name, Price, designid) {
        if(this.$route.query.ukey&&this.$route.query.ukey!==0){
            this.$router.push({
            path: '/DesignColor',
            query: {
            ukey:this.ukey
            }
        });
        }else{
             this.$router.push("/DesignColor");
        }
       
    
      this.$store.dispatch("ChangeDesginList", { Description, Name, Price, designid });
    }
    // next(){
    // 	this.$router.push({
    // 		path: '/DesignColor',
    // 		query: {
    // 			Name: this.Name,
    // 			Price:this.Price,
    // 		},

    // 	});
    // console.log(this.Name + this.Price)
    // }
  },
  //   watch(){
  //        if (localStorage.getItem("newDesginList") != null){
  //   var  Model= JSON.parse(localStorage.getItem('newDesginList'))
  //    this.Description = Model.Description;
  //         this.Name = Model.Name;
  //         this.Price = Model.Price;
  //        }else{
  //              this.getdexhList()
  //        }
  //   }
};
</script>

<style scoped>
@import "../../static/newlayout.css";
@import "../../static/global.css";
</style>


// WEBPACK FOOTER //
// src/views/Design.vue